import { _ep0, _mw0, command } from "../commandBuilder";
import { AbortMultipartUpload$ } from "../schemas/schemas_0";
export class AbortMultipartUploadCommand extends command(_ep0, _mw0, "AbortMultipartUpload", AbortMultipartUpload$) {
}
